import { createContext, useContext } from "react";
import type { RadioGroupContextValue } from "./types";

export const RadioGroupContext = createContext<RadioGroupContextValue | undefined>(undefined);

export function useRadioGroupContext(): RadioGroupContextValue {
  const context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error("RadioGroup.Radio must be rendered inside a RadioGroup");
  }
  return context;
}
